// src/features/geospatial/components/ZoneForm.jsx

import {
  Box,
  Typography,
  Divider,
  TextField,
  MenuItem,
  Stack,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";

export default function ZoneForm({
  form,
  setForm,
  countries,
  departments,
  provinces,
  polygon,
  loading,
  onSave,
  onClearMap,
}) {
  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setForm({
      countryId: "",
      departmentId: "",
      provinceId: "",
      name: "",
      description: "",
      isSpecial: false,
      multiplier: "1.00",
      resolution: 8,
    });

    onClearMap();
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" fontWeight={700}>
        Nueva Zona
      </Typography>

      <Typography variant="body2" color="text.secondary" mt={1}>
        Dibuje un polígono sobre el mapa y complete la información.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Stack spacing={2}>
        <TextField
          fullWidth
          select
          label="Pais"
          name="countryId"
          value={form.countryId}
          onChange={handleChange}
        >
          {countries.map((country) => (
            <MenuItem key={country.id} value={String(country.id)}>
              {country.name} - {country.code}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          select
          label="Departamento"
          name="departmentId"
          value={form.departmentId}
          onChange={handleChange}
        >
          {departments.map((department) => (
            <MenuItem key={department.id} value={String(department.id)}>
              {department.name} - {department.code}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          select
          label="Provincia"
          name="provinceId"
          value={form.provinceId}
          onChange={handleChange}
        >
          {provinces.map((province) => (
            <MenuItem key={province.id} value={String(province.id)}>
              {province.name} - {province.code}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          label="Nombre de la Zona"
          name="name"
          value={form.name}
          onChange={handleChange}
        />

        <TextField
          fullWidth
          multiline
          rows={4}
          label="Descripción breve"
          name="description"
          value={form.description}
          onChange={handleChange}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(form.isSpecial)}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  isSpecial: event.target.checked,
                }))
              }
              sx={{
                color: "#165c53",
                "&.Mui-checked": {
                  color: "#165c53",
                },
              }}
            />
          }
          label="Es especial"
          sx={{
            mx: 0,
            "& .MuiFormControlLabel-label": {
              color: "#000",
              fontWeight: 600,
            },
          }}
        />

        <TextField
          fullWidth
          type="number"
          label="Multiplicador"
          name="multiplier"
          value={form.multiplier}
          onChange={handleChange}
          inputProps={{ min: "1", step: "0.01" }}
        />

        <TextField
          fullWidth
          select
          label="Resolución H3"
          name="resolution"
          value={form.resolution}
          onChange={handleChange}
        >
          <MenuItem value={7}>7 - Cobertura amplia</MenuItem>

          <MenuItem value={8}>8 - Recomendado</MenuItem>

          <MenuItem value={9}>9 - Alta precisión</MenuItem>

          <MenuItem value={10}>10 - Muy alta precisión</MenuItem>
        </TextField>
      </Stack>

      <Divider sx={{ my: 2 }} />

      <Stack direction="row" spacing={2}>
        <Button
          fullWidth
          variant="outlined"
          color="inherit"
          startIcon={<ClearIcon />}
          onClick={handleClear}
        >
          Limpiar
        </Button>

        <Button
          fullWidth
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={onSave}
          disabled={loading}
        >
          {loading ? "Guardando..." : "Guardar"}
        </Button>
      </Stack>
    </Box>
  );
}
